var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    fill: "#D9D9D9",
    fillOpacity: 0.09,
    stroke: "#363636"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 32.75H19.5C18.75 32.75 18.2 32.72 17.73 32.65C14.41 32.29 13.75 30.3 13.75 27V21C13.75 17.7 14.41 15.71 17.76 15.34C18.2 15.28 18.75 15.25 19.5 15.25H28.5C29.25 15.25 29.8 15.28 30.27 15.35C33.59 15.71 34.25 17.7 34.25 21V27C34.25 30.3 33.59 32.29 30.24 32.66C29.8 32.72 29.25 32.75 28.5 32.75ZM19.5 16.75C18.82 16.75 18.34 16.78 17.95 16.83C15.92 17.06 15.25 17.69 15.25 21V27C15.25 30.31 15.92 30.94 17.92 31.17C18.34 31.23 18.82 31.25 19.5 31.25H28.5C29.18 31.25 29.66 31.22 30.05 31.17C32.08 30.95 32.75 30.31 32.75 27V21C32.75 17.69 32.08 17.06 30.08 16.83C29.66 16.77 29.18 16.75 28.5 16.75H19.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22.75H25.5C25.09 22.75 24.75 22.41 24.75 22C24.75 21.59 25.09 21.25 25.5 21.25H29C29.41 21.25 29.75 21.59 29.75 22C29.75 22.41 29.41 22.75 29 22.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0996 23C21.5496 23 21.0996 22.55 21.0996 22C21.0996 21.45 21.5396 21 22.0996 21H22.1096C22.6596 21 23.1096 21.45 23.1096 22C23.1096 22.55 22.6596 23 22.0996 23Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0996 23C18.5496 23 18.0996 22.55 18.0996 22C18.0996 21.45 18.5396 21 19.0996 21C19.6496 21 20.0996 21.45 20.0996 22C20.0996 22.55 19.6596 23 19.0996 23Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9998 28.25H19.0198C18.6098 28.25 18.2598 27.91 18.2598 27.5C18.2598 27.09 18.5898 26.75 18.9998 26.75H28.9998C29.4098 26.75 29.7498 27.09 29.7498 27.5C29.7498 27.91 29.4098 28.25 28.9998 28.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatVoice);
export default __webpack_public_path__ + "static/media/chat_voice.a3d2523354a26a44d9a28cf3cdb06415.svg";
export { ForwardRef as ReactComponent };